import classnames from 'classnames/bind'
import React, { useRef } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import Slider, { useSliderState } from '@unlikelystudio/react-slider'

import SliderArrows from '~/components/UI/SliderArrows'

import { useStyle } from '~/providers/StyleProvider'

import { getCSSThemeClassName } from '~/utils/get-css-theme-classname'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type SizeProps = {
  label?: string
  value?: string
  selected?: boolean
  disabled?: boolean
  isOutOfStock?: boolean
}

export type ProductSliderSelectProps = {
  className?: string
  hasArrows?: boolean
  items?: SizeProps[]
  theme?: 'large' | 'small'
  onChange?: (id, value) => void
}

function ProductSliderSelect({
  className,
  hasArrows,
  items,
  theme,
  onChange,
}: ProductSliderSelectProps) {
  const customSliderRef = useRef(null)

  const buttonStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12GroteskRegular,
    textStyling: GlobalTextStyling.Capitalize,
  })

  const [{ nextSlide, prevSlide, enableDrag }, setSliderState] =
    useSliderState()
    //Todo uncomment with slider newest versions
    /*  { enableDrag: true }, */

  const themeClassName = theme
    ? getCSSThemeClassName(css, theme, { prefix: 'theme-' })
    : null

  return (
    <div
      className={cx(css.ProductSliderSelect, className, themeClassName, {
        hasArrows: enableDrag && hasArrows,
      })}
      ref={customSliderRef}>
      <div className={css.wrapper}>
        <Slider
          className={css.slider}
          customSliderRef={customSliderRef}
          maxSlideIndexChange={1}
          setSliderState={setSliderState}
          autoIsSlider
          snap>
          {items?.map(
            ({ label, value, selected, disabled, isOutOfStock }, index) => (
              <button
                className={cx(css.button, buttonStyle, {
                  isSelected: selected,
                  isDisabled: disabled,
                  isOutOfStock,
                })}
                key={`button_${index}`}
                onClick={() => {
                  onChange && onChange(value, label)
                }}>
                {label}
              </button>
            ),
          )}
        </Slider>
      </div>
      {enableDrag && hasArrows && (
        <SliderArrows
          buttonClassName={css.sliderArrow}
          layout="inside"
          nextSlide={nextSlide}
          prevSlide={prevSlide}
        />
      )}
    </div>
  )
}

ProductSliderSelect.defaultProps = {
  theme: 'large',
  hasArrows: true,
}

export default ProductSliderSelect
